import { apiRequest } from "../http";

export const getAllEntities = () => apiRequest("/api/entities");

export const getEntityDetail = (entityId: string) =>
  apiRequest(`/api/entities/${entityId}`);

export const getEntityRelationships = (entityId: string) =>
  apiRequest<{
    id: string;
    name: string;
    entityType: { id: string; name: string };
    _count: {
      notes: number;
      fromRelationships: number;
      toRelationships: number;
    };
    relationships: Array<{
      id: string;
      relationshipType: string;
      relatedEntity: {
        id: string;
        name: string;
        entityType: { id: string; name: string };
      };
      direction: "outgoing" | "incoming";
    }>;
  }>(`/api/entities/${entityId}/relationships`);

export const getSharedEntities = (noteId: string, minSharedEntities = 1) =>
  apiRequest(
    `/api/entities/shared/${noteId}?minSharedEntities=${minSharedEntities}`,
  );

export const getConnectedNotes = (
  noteId: string,
  includeEntityBased = true,
  minSharedEntities = 1,
) =>
  apiRequest(
    `/api/entities/connected/${noteId}?includeEntityBased=${includeEntityBased}&minSharedEntities=${minSharedEntities}`,
  );

export const createUserInteraction = (data: {
  entityId?: string;
  noteId?: string;
  interactionType: string;
  metadata?: Record<string, unknown>;
}) =>
  apiRequest("/api/entities/interaction", {
    method: "POST",
    body: data,
  });

export const searchNotesByContext = (params: Record<string, string>) => {
  const searchParams = new URLSearchParams(params);
  return apiRequest(`/api/entities/search?${searchParams}`);
};

export const createNoteEdge = (data: {
  sourceNoteId: string;
  targetNoteId: string;
  relationshipType: string;
  metadata?: Record<string, unknown>;
}) =>
  apiRequest("/api/entities/edge", {
    method: "POST",
    body: data,
  });

export const processNoteEntities = (data: {
  noteId: string;
  userId?: string;
  metadata?: Record<string, unknown>;
}) =>
  apiRequest("/api/v2/process-note-entities", {
    method: "POST",
    body: {
      noteId: data.noteId,
      userId: data.userId || "anonymous",
      metadata: data.metadata,
    },
  });
